import { render, staticRenderFns } from "./TextHeroSection.vue?vue&type=template&id=0f4d9dc5&scoped=true&"
import script from "./TextHeroSection.vue?vue&type=script&lang=js&"
export * from "./TextHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./TextHeroSection.vue?vue&type=style&index=0&id=0f4d9dc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d9dc5",
  null
  
)

export default component.exports